import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * CompanyInfoCard - Card de informações (título + lista de linhas rótulo/valor)
 * Usado na página de detalhes da empresa (Admin Geral).
 * @param {Object} props
 * @param {ReactNode} props.icon
 * @param {string} props.title
 * @param {Array<{ label: string, value: ReactNode }>} props.rows
 * @param {ReactNode} [props.footer]
 */
function CompanyInfoCard({ icon, title, rows = [], footer }) {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        p: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon && (
          <Box sx={{ display: 'flex', color: '#5A80FB', fontSize: 20 }}>{icon}</Box>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.9375rem' }}>
          {title}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {rows.map((row, index) => (
          <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {row.label}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary', textAlign: 'right' }}>
              {row.value}
            </Typography>
          </Box>
        ))}
      </Box>

      {footer}
    </Card>
  );
}

export default CompanyInfoCard;
